import { DiversificationScheme } from '@/store/diversificationsApi';
import { useState } from 'react';

export interface PortfolioDiversificationFormData {
  Category: DiversificationScheme | null;
  SubCategory: DiversificationScheme | null;
  Detail: DiversificationScheme | null;
}
export interface PortfolioDiversificationFormState {
  values: PortfolioDiversificationFormData;
  showDiversifications: boolean;
  isValid: boolean;
}

const usePortfolioDiversificationForm = () => {
  const initialState = {
    values: {
      Category: null,
      SubCategory: null,
      Detail: null,
    },
    showDiversifications: false, // Users need to opt-in to setting allocations.
    isValid: true,
  };

  const [portfolioDiversificationForm, setPortfolioDiversificationForm] =
    useState<PortfolioDiversificationFormState>(initialState);

  const updatePortfolioDiversificationForm = (
    state: PortfolioDiversificationFormState,
  ) => {
    setPortfolioDiversificationForm(state);
  };

  const resetPortfolioDiversificationForm = () => {
    updatePortfolioDiversificationForm(initialState);
  };

  return {
    resetPortfolioDiversificationForm,
    portfolioDiversificationForm,
    updatePortfolioDiversificationForm,
  };
};

export default usePortfolioDiversificationForm;
